/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import { useMemo } from "react";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

function BodyMShapes({ _id }) {
  const navigate = useNavigate();

  const [bodyData, setBodyData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bodyData/getBodyDataImages`
      );
      console.log("Full Response:", response);

      const bodyData = response?.data?.data?.bodyData || [];
      console.log(bodyData, "Body Data");
      setBodyData(bodyData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //-----------------------------Delete api---------------------------------//
  const deleteBodyDataImages = async (_id) => {
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      const isConfirmed = window.confirm("Are you sure you want to delete this item?");
      if (!isConfirmed) return;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/deleteBodyDataImages/${_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      fetchData();

      if (!response.ok) {
        throw new Error("Failed to delete data");
      }
      const data = await response.json();
      console.log("Body data images deleted successfully:", data);

    } catch (error) {
      console.error("Error deleting body data images:", error.message);
    }
  };

  const handleDeleteButtonClick = (_id) => {
    deleteBodyDataImages(_id);
  };

  const rows = useMemo(
    () =>
      bodyData &&
      bodyData.map((data, index) => ({
        ...data,
        id: data._id,
      }))
  );

  const columns = [
    // { field: "_id", headerName: "ID", width: 90 },
    {
      field: "title",
      headerName: "Name",
      width: 150,
      editable: true,
    },

    {
      field: "bodyMeasurement",
      headerName: "Type",
      width: 150,
      editable: true,
    },
    {
      field: "input",
      headerName: "Image one",
      width: 150,
      renderCell: (params) => (
        <div>
          {params.row.images.length > 0 && (
            <img
              src={params.row.images[0]}
              alt="image"
              style={{ width: "100px", height: "auto" }}
            />
          )}
        </div>
      ),
    },
    {
      field: "value",
      headerName: "Image Two",
      width: 150,
      renderCell: (params) => (
        <div>
          {params.row.images.length > 1 && (
            <img
              src={params.row.images[1]}
              alt="image"
              style={{ width: "100px", height: "auto" }}
            />
          )}
        </div>
      ),
    },
    {
      field: "bm",
      headerName: "Image Three",
      width: 150,
      renderCell: (params) => (
        <div>
          {params.row.images.length > 2 && (
            <img
              src={params.row.images[2]}
              alt="image"
              style={{ width: "100px", height: "auto" }}
            />
          )}
        </div>
      ),
    },
    // {
    //   field: "image",
    //   headerName: "Image",
    //   width: 150,
    //   editable: true,
    // },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    //   editable: true,
    // },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip
                onClick={() =>
                  navigate(
                    `/edit-body-measurement-shapes/${param.row._id}`,
                    console.log({ state: { productId: param.row._id } }),
                    "AAAAAAAA"
                  )
                }
                title="Edit"
              >
                <IconButton>
                  <FaEdit style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDeleteButtonClick(param.row._id)}>
                  <MdDelete style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  // const rows = [
  //   {
  //     id: 1,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 2,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 3,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 4,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 5,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 6,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 7,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 8,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  //   {
  //     id: 9,
  //     title: "1",
  //     value: "test value",
  //     input: "Adidas",
  //     bm: "2",
  //     image: "test",
  //     status: "active",
  //   },
  // ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box sx={{height: 595, width: "100%", background: "white" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BodyMShapes;
